import React from "react";
import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import App from "./app";
import {Provider} from "react-redux";
import {store} from "./app/store/store";
import './../assets/styles/main.scss';

document.addEventListener("DOMContentLoaded", function () {
    const root = createRoot(document.getElementById("sb_ai_widget"));
    root.render(
        <StrictMode>
            <Provider store={store}>
                <App />
            </Provider>
        </StrictMode>
    );
});